import { render } from "./SlotEditForm.vue?vue&type=template&id=55ac4fd8&scoped=true"
import script from "./SlotEditForm.vue?vue&type=script&lang=js"
export * from "./SlotEditForm.vue?vue&type=script&lang=js"

import "./SlotEditForm.vue?vue&type=style&index=0&id=55ac4fd8&scoped=true&lang=css"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ac4fd8"]])

export default __exports__